<template>
	<CheckboxesDropdownComponent
		:id="filterKey"
		:label="label"
		:placeholder="placeholder"
		:options="options"
		:query="filter.search_query"
		:selection="active_values"
		:stretch="true"
		:search-disabled="searchDisabled"
		:loading="loading"
		@select="handleValueSelect"
		@update:query="handleSearchInputChange"
	/>
</template>

<script setup>
import CheckboxesDropdownComponent from '../CheckboxesDropdownComponent.vue';

import { ref, computed, onMounted, defineProps } from 'vue';
import { storeToRefs } from 'pinia';
import { useDatabaseFiltersStore } from '../../stores/database-filters';
import { useProjectFiltersStore } from '../../stores/project-filters';

const props = defineProps( {
	storeKey: {
		type: String,
		default: 'projects'
	},
	filterKey: {
		type: String,
		required: true
	},
	filterOptionsKey: {
		type: String,
		default: null
	},
	getOptionsMethod: {
		type: String,
		default: null
	},
	label: {
		type: String,
		default: ''
	},
	placeholder: {
		type: String,
		default: 'Search'
	},
	searchDisabled: {
		type: Boolean,
		default: false,
	},
} );

const filters_store = props.storeKey === 'database' ? useDatabaseFiltersStore() : useProjectFiltersStore();

const {
	setActiveFilterValue,
	removeActiveFilterValue,
	setFilterSearchQuery,
	resetPagination,
	updateQueryStringFromFilters,
} = filters_store;

const {
	[props.filterKey]: filter,
	[props.filterOptionsKey]: filter_options
} = storeToRefs( filters_store );

const options = computed( () => {
	return filter_options !== undefined ? filter_options.value : filter.value.options;
} );

const loading = ref( true );

const active_values = computed( () => {
	return filter.value.active.map( active_value => active_value.value );
} );

const handleValueSelect = ( value ) => { // eslint-disable-line snakecasejs/snakecasejs
	value.checked ? setActiveFilterValue( value, props.filterKey ) : removeActiveFilterValue( value, props.filterKey );
	resetPagination();
	updateQueryStringFromFilters();
};

const handleSearchInputChange = async( value ) => { // eslint-disable-line snakecasejs/snakecasejs
	setFilterSearchQuery( value, props.filterKey );
};

onMounted( async() => {
	if ( props.getOptionsMethod ) {
		await filters_store[props.getOptionsMethod]();
	}
	loading.value = false;
} );
</script>